import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import WComponent from "../../../../../../common/WComponent";
import "../../../afs-walkthrough.css";
import GmailService from "../../../../../../../services/GmailService";
import UtilityService from "../../../../../../../services/UtilityService";

const FALLBACK_FROM_ADDRESS = "info@getdocify.com";
const { alert } = UtilityService;

class ClientRequestsSection extends WComponent {
	state = {
		sendEmail: this.props.clientEmail || "",
		sending: false,
		sent: false,
		showPreview: false,
		editingId: null,
		editText: "",
		fromAddress: FALLBACK_FROM_ADDRESS,
	};

	render() {
	let { requestData, onSend, onUpdateItem, onDeleteItem, companyName, clientName, yearEnd } = this.props;
	let { sendEmail, sending, sent, showPreview, editingId, editText, fromAddress } = this.state;

	let request = requestData ? requestData.request : null;
	let items = requestData ? requestData.items || [] : [];
	let blockingItems = items.filter(function (i) { return i.blocking; });
	let nonBlockingItems = items.filter(function (i) { return !i.blocking; });
	let respondedBlocking = blockingItems.filter(function (i) { return i.responseStatus === "responded"; }).length;
	let totalBlocking = blockingItems.length;

	let handlePreview = async () => {
		if (!sendEmail.trim() || !request) return;

		let status = await GmailService.getStatus();
		if (status && status.connected && status.gmailAddress) {
			this.update({ fromAddress: status.gmailAddress });
		} else {
			this.update({ fromAddress: FALLBACK_FROM_ADDRESS });
		}

		this.update({ showPreview: true });
	};

	let handleConfirmSend = async () => {
		this.update({ sending: true });
		let result = null;
		if (onSend) result = await onSend({ requestId: request.id, contactEmail: sendEmail.trim() });
		this.update({ sending: false });

		if (result && result.draftCreated) {
			this.update({ sent: true });
			this.update({ showPreview: false });
			alert({ type: "success", text: "Draft created in " + (result.gmailAddress || "your Gmail") + ". Open Gmail Drafts to review and send." });
			return;
		}

		if (result && result.code === "gmail_not_connected") {
			alert({ type: "error", text: "Gmail not connected. Go to User Preferences → Connected Accounts to connect your Gmail before sending." });
			return;
		}

		if (result && result.message) {
			alert({ type: "error", text: result.message });
			return;
		}

		this.update({ showPreview: false });
	};

	function handleOpenGmailDrafts() {
		window.open("https://mail.google.com/mail/u/0/#drafts", "_blank");
	}

	let startEdit = (item) => {
		this.update({ editingId: item.id });
		this.update({ editText: item.question });
	};

	let saveEdit = async (item) => {
		if (onUpdateItem) await onUpdateItem({ id: item.id, question: editText });
		this.update({ editingId: null });
	};

	let ItemCard = ({ item }) => {
		let isResponded = item.responseStatus === "responded";
		let isEditing = editingId === item.id;
		let typeLabels = { clarification: "Clarification", documentation: "Documentation", confirmation: "Confirmation" };

		return (
			<div className={clsx("afs-client-req__item", isResponded && "afs-client-req__item--responded", item.blocking && "afs-client-req__item--blocking")}>
				<div className="afs-client-req__item-header">
					<span className={clsx("afs-client-req__item-dot", item.blocking ? "afs-client-req__item-dot--blocking" : "afs-client-req__item-dot--optional")} />
					{isEditing ? (
						<textarea className="afs-client-req__item-edit" rows={2} value={editText} onChange={(e) => { this.update({ editText: e.target.value }); }} autoFocus />
					) : (
						<span className="afs-client-req__item-question">{item.question}</span>
					)}
					<div className="afs-client-req__item-actions">
						{isEditing ? (
							<button className="afs-client-req__item-action" onClick={function () { saveEdit(item); }} title="Save"><Icon.Check size={13} /></button>
						) : (
							<button className="afs-client-req__item-action" onClick={function () { startEdit(item); }} title="Edit"><Icon.Edit3 size={13} /></button>
						)}
						<button className="afs-client-req__item-action" onClick={function () { if (onDeleteItem) onDeleteItem(item.id); }} title="Remove"><Icon.Trash2 size={13} /></button>
					</div>
				</div>
				<div className="afs-client-req__item-meta">
					{item.sourceCheckId && <span className="afs-client-req__item-source">{item.sourceCheckId}</span>}
					<span className="afs-client-req__item-type">{typeLabels[item.itemType] || item.itemType}</span>
					<span className={clsx("afs-client-req__item-status", isResponded && "afs-client-req__item-status--responded")}>
						{isResponded ? "Responded" : "Pending"}
					</span>
				</div>
				{isResponded && item.responseText && (
					<div className="afs-client-req__item-response">
						<span className="afs-client-req__item-response-label">Client response:</span>
						<span className="afs-client-req__item-response-text">{item.responseText}</span>
					</div>
				)}
				{item.files && item.files.length > 0 && (
					<div className="afs-client-req__item-files">
						{item.files.map(function (file) {
							return <span key={file.id} className="afs-client-req__item-file"><Icon.Paperclip size={11} /> {file.name}</span>;
						})}
					</div>
				)}
			</div>
		);
	};

	return (
		<div className="afs-client-req">
			<div className="afs-client-req__header">
				<span className="afs-client-req__title">Client Requests</span>
				{items.length > 0 && request && (
					<div className="afs-client-req__send-bar">
						<input className="afs-client-req__email-input" type="email" placeholder="Client email..." value={sendEmail} onChange={(e) => { this.update({ sendEmail: e.target.value }); }} />
						<button className="afs-client-req__send-btn" disabled={!sendEmail.trim() || sending} onClick={handlePreview}>
							<Icon.Edit3 size={13} /> {sending ? "Creating draft..." : sent ? "Recreate Draft" : "Create Draft"}
						</button>
						{sent && (
							<button className="afs-client-req__send-btn afs-client-req__send-btn--spaced" onClick={handleOpenGmailDrafts}>
								<Icon.ExternalLink size={13} /> Open Gmail Drafts
							</button>
						)}
					</div>
				)}
			</div>

			{items.length === 0 && (
				<div className="afs-client-req__empty">
					<Icon.Inbox size={32} color="#ccc" />
					<p>No client requests yet. Add items from the checklist using the clipboard button on any check.</p>
				</div>
			)}

			{blockingItems.length > 0 && (
				<div className="afs-client-req__group">
					<div className="afs-client-req__group-label">Blocking ({blockingItems.length})</div>
					{blockingItems.map(function (item) { return <ItemCard key={item.id} item={item} />; })}
				</div>
			)}

			{nonBlockingItems.length > 0 && (
				<div className="afs-client-req__group">
					<div className="afs-client-req__group-label">Non-blocking ({nonBlockingItems.length})</div>
					{nonBlockingItems.map(function (item) { return <ItemCard key={item.id} item={item} />; })}
				</div>
			)}

			{totalBlocking > 0 && (
				<div className={clsx("afs-client-req__readiness", respondedBlocking >= totalBlocking && "afs-client-req__readiness--ready")}>
					{respondedBlocking >= totalBlocking
						? <><Icon.CheckCircle size={14} color="#2e7d32" /> All blocking items responded — ready to proceed</>
						: <><Icon.AlertCircle size={14} color="#e67e22" /> {respondedBlocking} of {totalBlocking} blocking items responded — cannot finalize</>
					}
				</div>
			)}

			{request && request.sentAt && (
				<div className="afs-client-req__sent-info">
					Sent to {request.email} · Link: docs.getdocify.com/{request.shortId}
				</div>
			)}

			{showPreview && (
				<div className="afs-client-req__preview-overlay" onClick={() => { this.update({ showPreview: false }); }}>
					<div className="afs-client-req__preview" onClick={function (e) { e.stopPropagation(); }}>
						<div className="afs-client-req__preview-header">
							<span>Email Preview</span>
							<button className="afs-client-req__preview-close" onClick={() => { this.update({ showPreview: false }); }}><Icon.X size={16} /></button>
						</div>
						<div className="afs-client-req__preview-meta">
							<div><strong>To:</strong> {sendEmail}</div>
							<div><strong>Subject:</strong> Information Request — {clientName || "Client"}</div>
							<div><strong>From:</strong> {fromAddress}</div>
							<div className="afs-client-req__draft-hint">
								<Icon.Info size={11} className="afs-client-req__inline-icon" />
								This creates a draft in your Gmail Drafts folder. Review and send it from Gmail.
							</div>
						</div>
						<div className="afs-client-req__preview-body">
							<div className="afs-client-req__preview-email">
								<h3 className="afs-client-req__preview-title">Information Request</h3>
								<p className="afs-client-req__preview-intro">
									<strong>{companyName || "Your accountant"}</strong> has {items.length} question(s) regarding the compilation of <strong>{clientName || "your company"}</strong>{yearEnd ? " for the year ended " + yearEnd : ""}.
								</p>
								<p>Please respond to the following items:</p>
								<div className="afs-client-req__preview-items">
									{items.map(function (item, idx) {
										return (
											<div key={item.id} className="afs-client-req__preview-item">
												<span className="afs-client-req__preview-item-num">{idx + 1}. </span>
												<span>{item.question}</span>
												{item.blocking && <span className="afs-client-req__preview-required">Required</span>}
											</div>
										);
									})}
								</div>
								<p className="afs-client-req__preview-cta">
									<span className="afs-client-req__preview-btn">Open Request Form</span>
								</p>
								<p className="afs-client-req__preview-footnote">This is an automated message. Responses go directly to your accountant.</p>
							</div>
						</div>
						<div className="afs-client-req__preview-footer">
							<button className="afs-client-req__preview-cancel" onClick={() => { this.update({ showPreview: false }); }}>Cancel</button>
							<button className="afs-client-req__preview-confirm" disabled={sending} onClick={handleConfirmSend}>
								<Icon.Edit3 size={13} /> {sending ? "Creating draft..." : "Create Draft in Gmail"}
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
	}
}

export default ClientRequestsSection;
